import { mdiClose, mdiFileRemoveOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import '../../../../components/TravelRequest/UploadAttachments/DeleteDocument/DeleteDocument.scss';
import './EmployeeMasterDeleteConfirm.scss';

/** Last path segment; avoids long `Folder\file.pdf` strings in confirm copy. */
export function emBasenameOnly(name) {
  if (!name) return '';
  const s = String(name).trim();
  const parts = s.split(/[/\\]/);
  return parts[parts.length - 1] || s;
}

/** Travel-style delete confirmation for Employee Master sub-modals (z-index above `.ov`). */
function EmployeeMasterDeleteConfirm({
  isOpen,
  toggle,
  onConfirm,
  loading = false,
  message,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? undefined : toggle}
      centered
      size="xs"
      zIndex={21001}
    >
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="delete-document-cancel-icon">
            <Icon path={mdiFileRemoveOutline} size={0.7} />
          </div>
          <div>
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={toggle}
              disabled={loading}
            >
              <Icon path={mdiClose} size={1} />
            </button>
          </div>
        </div>
        <div>
          <h5>Confirmation</h5>
          <div className="em-delete-confirm__msg">{message}</div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="delete-document-cancel-btn w-100"
            disabled={loading}
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="delete-document-delete-btn w-100"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Yes, Delete'}
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default EmployeeMasterDeleteConfirm;
